import axios from 'axios';

function toFloat(value) {
  return parseFloat(value.toString().replace(/\s/g, '').replace(',', '.'));
}

export default {
  state: {
    accruals: [],
    total: 1,
    loading: false,
  },
  mutations: {
    SET_ACCRUALS(state, accruals) {
      state.accruals = accruals;
    },
    SET_TOTAL(state, value) {
      state.total = value;
    },
    SET_LOADING(state, value) {
      state.loading = value;
    },
    CALCULATE_PRICE(state) {
      state.accruals = state.accruals.map((item) => {
        item.price = parseFloat(
          toFloat(item.sum) / toFloat(item.number)
        ).toFixed(2);
        if(Number.isNaN(Number(item.price))) {
          item.price = 0;
        }
        return item;
      });
    },
  },
  actions: {
    loadAccruals({ commit }, params) {
      commit('SET_LOADING', true);
      const totatlPromise =  axios
      .get('api/accrual/total', { params: { contractNumber: params.contractNumber} });
      const accrualsPromise = axios
      .get('api/accrual/findByFilter', { params });

      Promise.all([accrualsPromise, totatlPromise]).then(
        (responses) => {
          commit('SET_ACCRUALS', responses[0].data);
          commit('SET_TOTAL', responses[1].data.total);          
          commit('CALCULATE_PRICE');
          commit('SET_LOADING', false);
        },
        (error) => {
          console.log(error);
          commit('SET_LOADING', false);
        }
      );
    },
  },
};
